import { type ThunkAction, type ThunkDispatch } from "@reduxjs/toolkit";

import { type ReduxState } from "../../types/reduxState";
import { type ThunkExtraArgument } from "../../types/thunk";
import { type ErrorReducerAction } from "../reducers/errorReducer";
import { type TermsAcceptanceActions } from "../reducers/termsAcceptanceReducer";
import { addError } from "./addErrorAction";

export const acceptTermsAndConditions: (
  restaurantUuid: string
) => ThunkAction<
  void,
  ReduxState,
  ThunkExtraArgument,
  TermsAcceptanceActions
> = (restaurantUuid: string) => {
  return (
    dispatch: ThunkDispatch<
      ReduxState,
      ThunkExtraArgument,
      TermsAcceptanceActions | ErrorReducerAction
    >,
    getState: () => ReduxState,
    { restaurantApi }: ThunkExtraArgument
  ) => {
    restaurantApi
      .acceptTermsAndConditions(restaurantUuid)
      .then(() => {
        dispatch({ type: "SET_TERMS_ACCEPTED", acceptanceStatus: true });
      })
      .catch(addError(dispatch));
  };
};

export const fetchTermsAcceptance: (
  restaurantUuid: string
) => ThunkAction<
  void,
  ReduxState,
  ThunkExtraArgument,
  TermsAcceptanceActions
> = (restaurantUuid: string) => {
  return (
    dispatch: ThunkDispatch<
      ReduxState,
      ThunkExtraArgument,
      TermsAcceptanceActions | ErrorReducerAction
    >,
    getState: () => ReduxState,
    { restaurantApi }: ThunkExtraArgument
  ) => {
    restaurantApi
      .fetchTermsAndConditionsAcceptance(restaurantUuid)
      .then((acceptanceStatus) => {
        dispatch({ type: "TERMS_ACCEPTANCE_FETCHED", acceptanceStatus });
      })
      .catch(addError(dispatch));
  };
};
